var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgTablesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53467 30.3405H25.0867V1.56982H1.53467V30.3405Z",
    fill: "#D7FCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67358 28.4383H23.0152V3.63208H3.67358V28.4383Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0483 7.86237H6.18884C5.90281 7.86237 5.67017 7.6408 5.67017 7.36774C5.67017 7.0956 5.90281 6.87402 6.18884 6.87402H15.0483C15.3343 6.87402 15.566 7.0956 15.566 7.36774C15.566 7.6408 15.3343 7.86237 15.0483 7.86237Z",
    fill: "#0392C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0483 24.6988H6.18884C5.90281 24.6988 5.67017 24.4772 5.67017 24.2042C5.67017 23.932 5.90281 23.7104 6.18884 23.7104H15.0483C15.3343 23.7104 15.566 23.932 15.566 24.2042C15.566 24.4772 15.3343 24.6988 15.0483 24.6988Z",
    fill: "#0392C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2488 16.1705H6.18884C5.90281 16.1705 5.67017 15.9489 5.67017 15.6758C5.67017 15.4037 5.90281 15.1821 6.18884 15.1821H11.2488C11.5348 15.1821 11.7675 15.4037 11.7675 15.6758C11.7675 15.9489 11.5348 16.1705 11.2488 16.1705Z",
    fill: "#DD5546"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8605 28.094H4.87866C4.46677 28.094 4.13211 27.7703 4.13211 27.3732V20.486H22.608V27.3732C22.608 27.7703 22.2733 28.094 21.8605 28.094ZM4.13211 19.4967H22.608V11.8915H4.13211V19.4967ZM4.87866 3.96076H21.8605C22.2733 3.96076 22.608 4.28439 22.608 4.68065V10.9031H4.13211V4.68065C4.13211 4.28439 4.46677 3.96076 4.87866 3.96076ZM21.8615 2.88599H4.87966C3.8528 2.88599 3.01758 3.69138 3.01758 4.68065V27.3732C3.01758 28.3634 3.8528 29.1688 4.87966 29.1688H21.8615C22.8884 29.1688 23.7245 28.3634 23.7245 27.3732V4.68065C23.7245 3.69138 22.8884 2.88599 21.8615 2.88599Z",
    fill: "#08162D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3560_1153",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 32
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.692383 0.615479H26.0503V31.3847H0.692383V0.615479Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3560_1153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79556 1.72765C2.72103 1.72765 1.84671 2.57074 1.84671 3.6069V28.3929C1.84671 29.429 2.72103 30.2721 3.79556 30.2721H22.9484C24.0229 30.2721 24.8973 29.429 24.8973 28.3929V3.6069C24.8973 2.57074 24.0229 1.72765 22.9484 1.72765H3.79556ZM22.9478 31.3846H3.7949C2.08442 31.3846 0.692383 30.0423 0.692383 28.3929V3.60695C0.692383 1.95755 2.08442 0.615234 3.7949 0.615234H22.9478C24.6582 0.615234 26.0503 1.95755 26.0503 3.60695V28.3929C26.0503 30.0423 24.6582 31.3846 22.9478 31.3846Z",
    fill: "#08162D"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablesIcon);
export default __webpack_public_path__ + "static/media/tables_icon.eb7ce373cb2cd6fade3d226920be8a53.svg";
export { ForwardRef as ReactComponent };